<template>
  <AppModal id="cannot-enable-scope-modal" :close-on-backdrop="true">

    <template #title>
      <h3 class="text-center mb-5">{{$t($getConst.pages.scope.scope_cannot_be_enabled) | capitalize}}</h3>
    </template>

    <template #content>
      <div class="text-danger" v-if="errors.length > 0">
        <ul>
          <li v-for="error in errors">{{$t($getConst.pages.scope[error])}}</li>
        </ul>
      </div>
    </template>

    <template #button>
      <AppConfirmButtons
        :first-button="false"
        @onCancel="closeModal"
      />
    </template>
  </AppModal>
</template>

<script>
  import AppConfirmButtons from "../../../components/common/utils/AppConfirmButtons";
  import AppModal from "../../../components/common/modals/AppModal";

  export default {
    name: "CannotEnableScopeModal",
    components: {AppModal, AppConfirmButtons},
    props: ['errors'],
    methods: {
      closeModal() {
        this.$emit('close');
        this.$bvModal.hide("cannot-enable-scope-modal");
      }
    }
  }
</script>

<style scoped>

</style>
